export default function getTagDefinitions(): string[] {
  return [
    'mlivl_jvp_107_hanninhauta',
    'mlivl_jvp_108_pitkajarvi',
    'mlivl_jvp_110_saksala',
    'mlivl_jvp_111_kinnari',
    'mlivl_jvp_112_huusharju',
    'mlivl_jvp_113_suojalammenpuisto',
    'mlivl_jvp_114_launiala_ja_hapetin',
    'mlivl_jvp_115_visulahti',
    'mlivl_jvp_116_tupalantie',
    'mlivl_jvp_117_salvos',
    'mlivl_jvp_119_sairilankoulukoti',
    'mlivl_jvp_120_helppanala',
    'mlivl_jvp_124_metsurinraitti',
    'mlivl_jvp_131_kaatopaikka',
    'mlivl_jvp_132_pursiala',
    'mlivl_jvp_134_rauhaniemi',
    'mlivl_jvp_140_siikasalmi',
    'mlivl_jvp_141_porrassalmentie',
    'mlivl_jvp_142_haahkalantie',
    'mlivl_jvp_143_kapalampi',
    'mlivl_jvp_144_kyyhkyla',
    'mlivl_jvp_145_silvasti',
    'mlivl_jvp_146_moisionpelto',
    'mlivl_jvp_147_laajatie',
    'mlivl_jvp_148_tuukkalantie',
    'mlivl_jvp_150_lentokentta',
    'mlivl_jvp_151_likolampi',
    'mlivl_jvp_160_satama',
    'mlivl_jvp_162_rolli',
    'mlivl_jvp_165_siekkila',
    'mlivl_jvp_166_varuskunta',
    'mlivl_jvp_167_yhdystie',
    'mlivl_jvp_168_savisilta',
    'mlivl_jvp_170_oravinmaki',
    'mlivl_jvp_171_itaportti',
    'mlivl_jvp_172_graani',
    'mlivl_jvp_174_ampumaradanpuisto',
    'mlivl_jvp_175_paasosenpuisto',
    'mlivl_jvp_176_antellinranta',
    'mlivl_jvp_177_antellinkatu',
    'mlivl_jvp_179_forsiuksenpolku',
    'mlivl_jvp_186_tuppurala',
    'mlivl_jvp_194_suonsaari',
    'mlivl_jvp_196_metsakouluntie',
    'mlivl_jvp_197_vatila',
    'mlivl_jvp_198_rouhiala',
    'mlivl_jvp_199_louhimo',
    'mlivl_jvp_210_tikkalantie',
    'mlivl_jvp_300_otava',
    'mlivl_jvp_301_oulanki',
    'mlivl_jvp_302_tikkala',
    'mlivl_jvp_303_orijarvi',
    'mlivl_jvp_305_kalliotie',
    'mlivl_jvp_306_teollisuustie',
    'mlivl_jvp_308_viilarintie',
    'mlivl_jvp_309_vuolingontie',
    'mlivl_jvp_310_kuusimaki',
    'mlivl_jvp_311_ristilampi',
    'mlivl_jvp_312_sairila',
    'mlivl_jvp_313_karankuja',
    'mlivl_jvp_314_naistinki',
    'mlivl_jvp_315_rantakylantie',
    'mlivl_jvp_316_karankuja',
    'mlivl_jvp_317_orijarvi',
    'mlivl_jvp_318_akkala',
    'mlivl_jvp_319_tulla',
    'mlivl_jvp_320_sahanmaki',
    'mlivl_jvp_321_karilantie',
    'mlivl_jvp_322_sirkolanmaki',
    'mlivl_jvp_323_tokero',
    'mlivl_jvp_325_vehkasilta',
    'mlivl_jvp_328_vuolinko',
    'mlivl_jvp_330_ruhalanniemi',
    'mlivl_jvp_332_tormatie',
    'mlivl_jvp_450_anttolanhovi_jvp',
    'mlivl_jvp_451_pajatie_jvp',
    'mlivl_jvp_452_timontie_jvp',
    'mlivl_jvp_453_sahala_jvp',
    'mlivl_jvp_454_satamatori_jvp',
    'mlivl_jvp_455_suotorpantie_jvp',
    'mlivl_jvp_456_taipaleenlahti_jvp',
    'mlivl_jvp_457_tiilisaari_jvp',
    'mlivl_jvp_751_hummerikuja1',
    'mlivl_jvp_752_huvilava',
    'mlivl_jvp_754_palotalli',
    'mlivl_jvp_755_rajakatu',
    'mlivl_jvp_757_hiekkaranta',
    'mlivl_jvp_851_paapumppaamo',
    'mlivl_jvp_8511_paapumppaamo-p1',
    'mlivl_jvp_8512_paapumppaamo-p2',
    'mlivl_jvp_852_pellosniemi',
    'mlivl_jvp_853_brahentie',
    'mlivl_jvp_854_puustelli',
    'mlivl_jvp_855_muurikki',
    'mlivl_jvp_856_joutsenranta',
    'mlivl_jvp_857_huumo',
    'mlivl_jvp_860_joutsenlahti',
    'mlivl_jvp_861_kisakaari',
    'mlivl_jvp_862_ahoranta',
    'mlivl_jvp_904_metsolanraitti',
    'mlivl_jvp_905_valiaho',
    'mlivl_jvp_928_opinraitti',
    'mlivl_jvpuh_6_ristiina_polyrex',
    'mlivl_jvpuh_6_ristiina',
    'mlivl_jvpuh_750_haukivuori',
    'mlivl_jvpuh_anttola_system',
    'mlivl_jvpuh_anttola',
    'mlivl_jvpuh_sn_suomenniemi',
    'mlivl_kv_haukivuori_system',
    'mlivl_kv_kantakaupunkijv_system',
    'mlivl_ma_180_oravinmaki',
    'mlivl_ma_181_visulahti',
    'mlivl_ma_182_rokkala',
    'mlivl_ma_183_lahemaki',
    'mlivl_ma_187_tuppurala',
    'mlivl_ma_188_ramala',
    'mlivl_ma_189_vatila',
    'mlivl_ma_190_kallajarvi',
    'mlivl_ma_304_rantakyla',
    'mlivl_ma_331_ruhalanniemi',
    'mlivl_ma_401_kirkonvarkaus',
    'mlivl_ma_402_kaatlampi',
    'mlivl_ma_404_heinalahti',
    'mlivl_ma_406_joenkangas',
    'mlivl_ma_408_niittulahti',
    'mlivl_ma_410_levahdyspaikka',
    'mlivl_ma_412_anttola',
    'mlivl_ma_704_vesikansantie',
    'mlivl_ma_707_kaarteentie',
    'mlivl_ma_71_siikasalmi',
    'mlivl_ma_711_haukilampi',
    'mlivl_ma_712_tuliniemi',
    'mlivl_ma_713_kurkisensaari',
    'mlivl_ma_715_kantala',
    'mlivl_metis_10_rantakyla',
    'mlivl_metis_2_kantak_jv',
    'mlivl_metis_7_kantakpv',
    'mlivl_mv_405_haukka-korhola',
    'mlivl_mv_407_parkkila',
    'mlivl_mv_411_hovinkyla',
    'mlivl_pka_138_tarsala',
    'mlivl_pka_139_satukirjankatu',
    'mlivl_pka_184_sairila',
    'mlivl_pka_202_valkosenmaki',
    'mlivl_pka_203_karikko',
    'mlivl_pka_204_sahanmaki',
    'mlivl_pka_205_koivikko',
    'mlivl_pka_209_haukilampi',
    'mlivl_pka_316_hermanni',
    'mlivl_pka_403_honkalampi',
    'mlivl_pka_409_seppalankyla',
    'mlivl_pka_420_anttolanhovi',
    'mlivl_pka_600_tikkala',
    'mlivl_pka_702_saksalanharju',
    'mlivl_pka_703_hakkila',
    'mlivl_pka_90_tupala',
    'mlivl_pka_903_kirkonkylantie',
    'mlivl_pka_94_tuukkala',
    'mlivl_pka_95_laajalampi',
    'mlivl_pka_97_tusku',
    'mlivl_pka_98_varuskunta',
    'mlivl_pvp_101_saksala',
    'mlivl_pvp_105_sammonkatu',
    'mlivl_pvp_106_nummikuja',
    'mlivl_pvp_121_visulahti',
    'mlivl_pvp_122_katajalahti',
    'mlivl_pvp_123_seurala',
    'mlivl_pvp_153_savilahdenkatu',
    'mlivl_pvp_173_raviradantie',
    'mlivl_pvp_193_hietasen_alikulku',
    'mlivl_pvp_328_vuolinko',
    'mlivl_svp_329_ronkaharju',
    'mlivl_system_5_ristiinavl',
    'mlivl_system_7_kantakaupunkipv',
    'mlivl_vl_200_otava',
    'mlivl_vl_3_pursiala_hasl_1_33qirca3',
    'mlivl_vl_3_pursiala_hasl_1_34fv1',
    'mlivl_vl_3_pursiala_hasl_1_34p24',
    'mlivl_vl_3_pursiala_hasl_1_34p25',
    'mlivl_vl_3_pursiala_hul_1_33p15',
    'mlivl_vl_3_pursiala_hul_1_35fiq8',
    'mlivl_vl_3_pursiala_hul_1_35p16',
    'mlivl_vl_3_pursiala_hysl_1_34p22',
    'mlivl_vl_3_pursiala_hysl_1',
    'mlivl_vl_3_pursiala_ilm_1_32fiq1',
    'mlivl_vl_3_pursiala_ilm_2_32fiq4',
    'mlivl_vl_3_pursiala_ilm_3_32fiq2',
    'mlivl_vl_3_pursiala_ilm_4_32fiq3',
    'mlivl_vl_3_pursiala_jvk_1_31fiq5',
    'mlivl_vl_3_pursiala_jvk_1_31fiq6',
    'mlivl_vl_3_pursiala_jvk_1_31m1',
    'mlivl_vl_3_pursiala_jvk_1_31m2',
    'mlivl_vl_3_pursiala_kasl_1_33qirca3',
    'mlivl_vl_3_pursiala_kasl_1_34m42',
    'mlivl_vl_3_pursiala_paut_1',
    'mlivl_vl_3_pursiala_pvk_1_31p1',
    'mlivl_vl_3_pursiala_pvk_1',
    'mlivl_vl_3_pursiala_pvk_10_31lia10',
    'mlivl_vl_3_pursiala_pvk_10_31p10',
    'mlivl_vl_3_pursiala_pvk_11_31lia11',
    'mlivl_vl_3_pursiala_pvk_11_31p11',
    'mlivl_vl_3_pursiala_pvk_12_31lia12',
    'mlivl_vl_3_pursiala_pvk_12_31p12',
    'mlivl_vl_3_pursiala_pvk_3_31p3',
    'mlivl_vl_3_pursiala_pvk_4_31lia4',
    'mlivl_vl_3_pursiala_pvk_4_31p4',
    'mlivl_vl_3_pursiala_pvk_5_31lia5',
    'mlivl_vl_3_pursiala_pvk_5_31p5',
    'mlivl_vl_3_pursiala_pvk_6_31p6',
    'mlivl_vl_3_pursiala_pvk_7_31lia7',
    'mlivl_vl_3_pursiala_pvk_7_31p7',
    'mlivl_vl_3_pursiala_pvk_7_31ti7',
    'mlivl_vl_3_pursiala_pvk_8_31lia8',
    'mlivl_vl_3_pursiala_pvk_8_31p8',
    'mlivl_vl_3_pursiala_pvk_9_31lia9',
    'mlivl_vl_3_pursiala_pvk_9_31p9',
    'mlivl_vl_3_pursiala_pvp_1_35fiq10',
    'mlivl_vl_3_pursiala_pvp_1_35fiq12',
    'mlivl_vl_3_pursiala_pvp_1_35fiq9',
    'mlivl_vl_3_pursiala_pvp_1_35lisa15',
    'mlivl_vl_3_pursiala_pvp_1_35liza14',
    'mlivl_vl_3_pursiala_pvp_1_35m33',
    'mlivl_vl_3_pursiala_pvp_1_35m34',
    'mlivl_vl_3_pursiala_pvp_1_35m35',
    'mlivl_vl_3_pursiala_pvp_1_35p18',
    'mlivl_vl_3_pursiala_pvp_1_35p19',
    'mlivl_vl_3_pursiala_pvp_1_35p20',
    'mlivl_vl_3_pursiala_pvp_1_35pia1',
    'mlivl_vl_3_pursiala_pvp_1_35ps18',
    'mlivl_vl_3_pursiala_pvp_1_35ps19',
    'mlivl_vl_3_pursiala_pvp_1_35ps20',
    'mlivl_vl_3_pursiala_selk_1_32m36',
    'mlivl_vl_3_pursiala_selk_1_32m37',
    'mlivl_vl_3_pursiala_selk_1_32m38',
    'mlivl_vl_3_pursiala_selk_1',
    'mlivl_vl_3_pursiala_selk_2_32m39',
    'mlivl_vl_3_pursiala_selk_2_32m40',
    'mlivl_vl_3_pursiala_selk_2_32m41',
    'mlivl_vl_3_pursiala_tyl_1_35x1',
    'mlivl_vl_3_pursiala_tyl_1_35x2',
    'mlivl_vl_413_anttola',
    'mlivl_vl_5_ristiina',
    'mlivl_vl_70_hietalahti',
    'mlivl_vl_8_hanhikangas',
    'mlivl_vl_900_kirkonkyla',
    'mlivl_vl_902_koiralahti',
    'mlivl_vl_pursiala_3_km7_rkt1_5',
    'mlivl_vt_206_otava',
    'mlivl_vt_414_anttola',
    'mlivl_vt_85_kirjala',
    'mlivl_vt_86_tuukkala'
  ];
}
